// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__MMcR7","label":"Category_label__3DGrm","content":"Category_content__1DCze","header":"Category_header__ofUPn","location":"Category_location__32Su7"};